var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "page-dialog center-dialog",
      attrs: {
        "append-to-body": "",
        modal: _vm.$attrs.modal,
        title: _vm.dialogTitle,
        "close-on-click-modal": false,
        visible: _vm.visible,
        width: "600px",
        "destroy-on-close": "",
      },
      on: {
        close: function ($event) {
          return _vm.$emit("update:visible", false)
        },
        closed: _vm.handleClosed,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "formRef",
          attrs: {
            model: _vm.form,
            rules: _vm.formRules,
            "label-width": "150px",
            size: "small",
          },
        },
        [
          !_vm.isEdit
            ? _c(
                "el-form-item",
                { attrs: { label: "会员账号", prop: "username" } },
                [
                  _c(
                    "div",
                    { staticClass: "username-row" },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入会员账号",
                          maxlength: "20",
                          "show-word-limit": "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.username,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "username", $$v)
                          },
                          expression: "form.username",
                        },
                      }),
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-left": "10px" },
                          attrs: {
                            size: "small",
                            type: "primary",
                            loading: _vm.checkLoading,
                          },
                          on: { click: _vm.handleCheckUser },
                        },
                        [_vm._v("查询")]
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _c(
                "el-form-item",
                { attrs: { label: "会员账号" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.username,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "username", $$v)
                      },
                      expression: "form.username",
                    },
                  }),
                ],
                1
              ),
          !_vm.isEdit && _vm.isUserExists && _vm.canBindNumber === 0
            ? _c("div", { staticClass: "error-message" }, [
                _vm._v("绑卡数已达上限"),
              ])
            : _vm._e(),
          _vm.showAddFormItem
            ? _c(_vm.countryFieldsComponent, {
                key: _vm.siteCountry,
                ref: "countryFieldsRef",
                tag: "component",
                attrs: { form: _vm.form },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.handleCancel } },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: {
                size: "small",
                type: "primary",
                disabled: !_vm.showAddFormItem,
              },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v("确认")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }